import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { ToastrService } from 'ngx-toastr';
import { ImageRequest } from '../../../../../models/api-dam/image/image-request.model';
import { ImageResponseGet } from '../../../../../models/api-dam/image/image-response.model';
import { ImageService } from '../../../../../services/api-dam/image/image.service';
import { TRUE } from '../../../../../utils/config/const';

@Component({
  selector: 'app-immagini-crop',
  templateUrl: './immagini-crop.component.html',
  styleUrls: ['./immagini-crop.component.css']
})
export class ImmaginiCropComponent implements OnInit {

  @ViewChild ('cropperImage') cropperImage;
  @Input() public idImage:number;

  formBuilder: FormGroup;
  request:ImageRequest = new ImageRequest();
  response:ImageResponseGet = new ImageResponseGet();
  
  imageBlob: Blob;
  imageFormat:string = "jpg"
  imageChangedEvent: any = '';
  croppedImage: any = '';

  files:File[]=[];
  filesSRC:any;
  isButtonSaveDisabled:boolean;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private imageService:ImageService,
    private toastr: ToastrService,
  ) { 
    this.initForm();
  }

  ngOnInit(): void {
    this.loadDataById(this.idImage);
  }

  initForm(){
    this.formBuilder = this.fb.group({
      name: ['',[Validators.required]],
      url: '',
      alt: '',
      summary: '',
      tags: '',
      copyright: '',
      filename:['',[Validators.required]],
    });
    this.isButtonSaveDisabled = false;
  }

  get form(){return this.formBuilder;}
  get formControls() { return this.formBuilder.controls; }

  loadDataById(id){
    this.imageService.getEntity(id).subscribe(
      (response:ImageResponseGet) => {
        
        this.setFormValue(response);
        this.response = response;
        this.imageFormat = this.getFormatImagByFilename(response.publicUrl);

        this.downloadImage(response);
      },
      (error: HttpErrorResponse)=>{
        this.toastr.error('Si è verificato un errore durante il caricamento delle informazioni dell\'immagine' , 'Modifica immagine', {
          timeOut: 5000
        });
      }
    );
  }

  getFormValue(){
    let request = new ImageRequest();
    request.name = this.formBuilder.controls['name'].value;
    request.url = this.formBuilder.controls['url'].value;
    request.alt = this.formBuilder.controls['alt'].value;
    request.summary = this.formBuilder.controls['summary'].value;
    request.tags = this.formBuilder.controls['tags'].value;
    request.copyright = this.formBuilder.controls['copyright'].value;
    request.filename = this.formBuilder.controls['filename'].value;
    return request;
  }

  setFormValue(response){
    let time = new Date().getTime();
    let name = response.name+"_"+time
    let filename = "";
    let lastPos = response.filename.lastIndexOf(".");
    filename = response.filename.substr(0,lastPos) + "_" + time +  response.filename.substr(lastPos);
    this.formBuilder.controls['name'].setValue(name);
    this.formBuilder.controls['url'].setValue("");
    this.formBuilder.controls['alt'].setValue("");
    this.formBuilder.controls['summary'].setValue("");
    this.formBuilder.controls['tags'].setValue("");
    this.formBuilder.controls['copyright'].setValue("");
    this.formBuilder.controls['filename'].setValue(filename);
  }

  blobToFile(theBlob: Blob, fileName:string): File {
    let b: any = theBlob;
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    //Cast to a File() type
    return <File>theBlob;
  }

 convertBase64ToBlob(base64Image: string) {
    // Split into two parts
    const parts = base64Image.split(';base64,');
  
    // Hold the content type
    const imageType = parts[0].split(':')[1];
  
    // Decode Base64 string
    const decodedData = window.atob(parts[1]);
  
    // Create UNIT8ARRAY of size same as row data length
    const uInt8Array = new Uint8Array(decodedData.length);
  
    // Insert all character code into uInt8Array
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
  
    // Return BLOB image after conversion
    return new Blob([uInt8Array], { type: imageType });
  }


  downloadImage(infoImage){
    this.imageService.download(infoImage.id).subscribe(
      (response) => {
        let blob = new Blob([response], { type: this.imageFormat });
        this.imageBlob = blob;
      },
      (error: HttpErrorResponse)=>{
        console.log(error);
      }
    );
  }


  getFormatImagByFilename(filename){
    let res = "";
    let pos = -1;
    if(filename!= null && typeof filename != typeof undefined){
      let name = filename.trim();
      if(name.length > 0){
        pos = name.lastIndexOf(".")+1;
      }
      res = name.substr(pos);
    }
    return "/image/"+res;
  }


  
  save(){
    let request = this.getFormValue();
    let blobfile = this.convertBase64ToBlob(this.croppedImage);
    let file = this.blobToFile(blobfile,request.filename);
    this.imageService.create(request,file).subscribe(
        (response)=>{
          this.toastr.success('Immagine ritagliata creata con successo', 'Crea immagine ritagliata');
          this.isButtonSaveDisabled = true;
          this.activeModal.close(response);
        },
        (error)=>{
          console.log(error);
          this.isButtonSaveDisabled = true;
          this.toastr.error('Si è verificato un errore durante la creazione dell\'immagine ritagliata' , 'Crea immagine ritagliata fallita', {
            timeOut: 5000
          });
        }
      ); 
  }


  clickButtonSave(){
    if(this.formBuilder.status === 'VALID' && this.formBuilder.touched == TRUE){
      this.isButtonSaveDisabled = true;
      this.save();
    }
  }
  clickButtonCancel(){
    this.activeModal.close('CLOSE');
  }

  
  //Cropper
  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
      this.formBuilder.markAsTouched();
      this.croppedImage = event.base64;
  }
  imageLoaded() {
      // show cropper
  }
  cropperReady() {
      // cropper ready
  }
  loadImageFailed() {
      // show message
  }


}
